<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-flex align-items-center">

                <form class="search-box position-relative me-15" @submit.prevent="rechercher">
                    <input type="text" name="mot" v-model="searchTerm" @keyup="rechercher"
                        class="form-control shadow-none text-black rounded-0 border-0"
                        placeholder="Rechercher une affectation" />
                    <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
                        <i class="flaticon-search-interface-symbol"></i>
                    </button>
                </form>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Code de la file
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Libellé de la file
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Nom & Prénoms des Agents affectés à chaque file
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Date d'Affectation de la file aux agents
                            </th>
                            <th scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                                Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(affectation, index) in affectationsParFile" :key="index">

                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ affectation.validationqueue?.code }}
                            </td>

                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ affectation.validationqueue?.name }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <span v-for="(agent, i) in affectation.agents" :key="i" class="badge bg-primary me-2">
                                    {{ agent.nom }} {{ agent.prenom }}
                                </span>
                            </td>

                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ format(affectation.createdAt) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                                <div class="dropdown">
                                    <span class="badge text-white bg-primary fs-15 dropdown-toggle"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        Actions
                                        <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                                    </span>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <router-link
                                                :to="{ name: 'RetirerAgentPage', params: { validationQueueId: affectation.validationqueue.id }, query: { name: affectation.validationqueue.name } }"
                                                class="dropdown-item d-flex align-items-center"><i
                                                    class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Gérer les
                                                agents</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">

                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="affectationsParFile.length"
                    :limit="limit" @paginate="handlePaginate" />

            </div>
        </div>
    </div>

</template>

<script lang="ts">

import { defineComponent, onMounted, ref, watch, computed } from "vue";

import ApiService from "../../services/ApiService";
import { format_date, suppression, error } from "../../utils/utils";
import axios from 'axios';
import Swal from "sweetalert2";
import PaginationComponent from '../../components/Utilities/Pagination.vue';
import JwtService from "../../services/JwtService";
import { TypeFretPaiement } from "@/models/TypeFretPaiement";
import AddModalValidationTask from "./AddModalValidationTask.vue";
import { ValidationTask } from "@/models/ValidationTask";
import { formatDate } from "@fullcalendar/core";
import { AgentValidationQueues } from "@/models/agent_validation_queues";
import { useRoute } from "vue-router";

export default defineComponent({
    name: "ListeAffectation",
    components: {
        PaginationComponent
    },
    setup: () => {
        // const modules = {

        // };

        const affectations = ref<Array<AgentValidationQueues>>([]);
        const affectation = ref<AgentValidationQueues>();
        // const addModalValidationTaskRef = ref<null | HTMLElement>(null);
        const selectedItem = ref(0);
        const format = (d) => d ? formatDate(d) : "";

        // BEGIN PAGINATE
        const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);
        const route = useRoute();


        // const handlePaginate = ({ page_, limit_ }) => {
        //     try {
        //         page.value = page_;
        //         getAllAffectation(page_, limit_);
        //     } catch (error) {
        //        //
        //     }
        // };


        // END PAGINATION
        function getAllAffectation(page = 1, limi = 10, searchTerm = "") {
            const user = JwtService.getUser();
            console.log("user:", user);
            if (!user) return error("Utilisateur non connecté");
            const userId = user.userId.replace(/\/+$/, '').trim();
            if (!userId) return error("Utilisateur non connecté");
            return ApiService.get(`agvalidationqs?page=${page}&limit=${limi}&mot=${searchTerm}&userCreationId=${userId}`)
                .then(({ data }) => {
                    affectations.value = data.data.data;
                    console.log("affectationssss", affectations.value)
                    totalPages.value = data.data.totalPages;
                    limit.value = data.data.limit;
                    totalElements.value = data.data.totalElements;
                })
                .catch(({ response }) => {
                    error(response.data.message)
                });
        }

        const handlePaginate = ({ page_, limit_ }: { page_: number; limit_: number }) => {
            page.value = page_;
            getAllAffectation(page_, limit_, searchTerm.value);
        };
        function rechercher() {
            console.log("Recherche lancée avec:", searchTerm.value);
            getAllAffectation(page.value, limit.value, searchTerm.value);
        }


        onMounted(() => {
            getAllAffectation();
        });

        const affectationsParFile = computed(() => {
            const map: Record<string, any> = {};

            for (const aff of affectations.value) {
                const queueId = aff.validationqueue?.id;
                if (!queueId) continue;

                if (!map[queueId]) {
                    map[queueId] = {
                        validationqueue: aff.validationqueue,
                        agents: [],
                        createdAt: aff.createdAt
                    };
                }

                map[queueId].agents.push(aff.user);
            }

            return Object.values(map);
        });


        // function moddifier(EditValidationTask: ValidationTask) {
        //     validationTask.value = EditValidationTask;
        //     selectedItem.value = EditValidationTask.id;
        // }
        const recharger = () => {
            getAllAffectation();
        };

        const privileges = ref<Array<string>>(JwtService.getPrivilege());

        const checkPermission = (name) => {
            return privileges.value.includes(name);
        }
        return {
            // modules,
            format,
            checkPermission,
            selectedItem,
            affectations,
            recharger,
            affectationsParFile,
            suppression,
            // moddifier,
            page,
            totalPages,
            limit,
            totalElements,
            // getAllValidationTask,
            handlePaginate,
            searchTerm,
            rechercher,
            // getStatusBadgeClass,
            // getPriorityDisplay
        };
    },
});
</script>
